import PageToolbar from '@/components/linear/page-toolbar';
import { projectsPath } from '@/lib/linear-paths';
import ProjectForm from '@/pages/projects/components/project-form';
import type { Company } from '@/types/company';
import type { Project } from '@/types/project';

interface Props {
  project: Pick<Project, 'name' | 'endState' | 'companyId' | 'singleShot'> & {
    id: string | null;
  };
  companies: Company[];
}

export default function New({ project, companies }: Props) {
  return (
    <div className="ln-page">
      <PageToolbar title="New project" showNew={false} />
      <div className="ln-page-scroll">
        <div className="ln-form-page">
          <h1>New project</h1>
          <p className="ln-lede">Create work under a company with a clear end state.</p>
          <ProjectForm
            project={project}
            companies={companies}
            action={projectsPath()}
            method="post"
            submitLabel="Create project"
          />
        </div>
      </div>
    </div>
  );
}
